/* eslint-disable camelcase */
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// material
import {
  Card,
  Table,
  Stack,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  CircularProgress,
} from '@mui/material';
// components
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead } from '../../sections/user';
import { PaymentListToolbar } from '../../sections/wallet';
// mock
import instance from '../../api/axiosRequest';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'id', label: 'SN', alignRight: false },
  { id: 'amount', label: 'Amount', alignRight: false },
  { id: 'service_id', label: 'Service ID', alignRight: false },
  { id: 'is_wallet_transaction', label: 'Wallet Transaction', alignRight: false },
  { id: 'createdAt', label: 'Created At', alignRight: false },
  { id: 'order_status', label: 'Complete', alignRight: false },
  { id: '' },
];

export default function Payments() {
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState('desc');
  const [dates, setDates] = useState();
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('createdAt');
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    const getPayments = async () => {
      setLoading(true);
      let query = '?size=50&page_number=0';
      if (dates) query += `&start_date=${dates[0]}&end_date=${dates[1]}`;
      try {
        const { data } = await instance.get(`/payment/getPayments${query}`);
        setRows(data.data.rows);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log(error.response);
      }
    };
    getPayments();
  }, [dates]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1 / 2}>
        <Typography variant="h5" gutterBottom>
          Payments
        </Typography>
      </Stack>

      <Card>
        <PaymentListToolbar numSelected={selected.length} setDates={setDates} />

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={rows.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                onSelectAllClick={handleSelectAllClick}
              />
              {!loading && (
                <TableBody>
                  {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id, amount, createdAt, service_id, is_wallet_transaction, order_status } = row;
                    const isItemSelected = selected.indexOf(id) !== -1;

                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, id)} />
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {id}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {amount}
                        </TableCell>
                        <TableCell align="left">{service_id}</TableCell>
                        <TableCell align="left">{sentenceCase(Boolean(is_wallet_transaction).toString())}</TableCell>
                        <TableCell align="left">{new Date(createdAt).toLocaleString()}</TableCell>
                        <TableCell align="left">{sentenceCase(Boolean(order_status).toString())}</TableCell>

                        {/* <TableCell align="right">
                            <PaymentMoreMenu row={row} />
                          </TableCell> */}
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
              )}

              {rows.length === 0 && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                      {loading ? <CircularProgress /> : <SearchNotFound searchQuery="" />}
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
              {/* {!loading && <Stack sx={{width: "100%", height: 100}} justifyContent="center" alignItems="center">
                  <CircularProgress />
                </Stack>} */}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
